import React from 'react';
import CMPImage from 'components/global/image';

const StructureIcon: React.FunctionComponent = () => {
  const src = '/images/structure.png';
  return <CMPImage asset={{ src, alt: 'Character' }} width={16} height={18} />;
};
export default StructureIcon;
